/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useMemo } from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

const mock = [
  {
    
    description:
      'Fancy Dress',
    href : '/fancy-dress-2025'
 
  },
  {
    description:
      'Environment Day Celebration',
    href : '/environment-day-2025'
 
  },
   {
    description:
      'National and Cultural Celebrations',
    href : '/national-and-cultural-celebrations'
 
  },
  {
    description:
      'Dussehra Celebration',
    href : '/dussehra-celebrations-pre-primary-2025'
 
  },
  {
    description:
      'WOW-Whispers of Wisdom',
    href : '/wow-whispers-of-wisdom-2025'
 
  },
  {
    description:
      'KG Story Telling',
    href : '/kg-story-telling-2025'
 
  },
  {
    description:
      'Montessori Story Telling',
    href : '/mont-story-telling-2025'
 
  },
   {
    description:
      'Super Heroes Without Capes',
    href : '/super-heroes-without-capes-2025'
 
  },
   {
    description:
      'Rainbow of Values',
    href : '/rainbow-of-values-2025'
 
  },
   {
    description:
      'Colours Around The World',
    href : '/colours-around-the-world-2025'
 
  },
   {
    description:
      'Five Elements Of Nature',
    href : '/five-elements-of-nature-2025'
 
  },
   {
    description:
      'Around India in 5 Minutes',
    href : '/around-india-in-5-minutes-2025'
 
  },
   {
    description:
      'Extinct & Endangered Animals',
    href : '/extinct-and-endangered-animals-2025'
   },
   {
    description:
      'Community Helpers',
    href : '/community-helpers-2025'
   },
   {
    description:
      'Joy of Reading',
    href : '/joy-of-reading-2025'
   },
   {
    description:
      'Magic of Friendship',
    href : '/magic-of-friendship-2025'
   },
   {
    description:
      'Beauty of Nature',
    href : '/beauty-of-nature-2025'
   },
   {
    description:
      'Little Star Silver Zone Olympiad',
    href : '',
   }
];

const PreprimarySidebar2025 = () => {
  const [config, setConfig] = useState({ base_image_url: '' });
  
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const pdf4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Scholastic_2024-25/Sliver-Zone-Result-2025-26.pdf`;
  
  const mockWithPdf = useMemo(() => {
    return mock.map((item, index) => {
      if (index === mock.length - 1) {
        return { ...item, href: pdf4 };
      }
      return item;
    });
  }, [pdf4]);

  return (
    <Box component={Card} variant={'outlined'} padding={2}>
      
      <Typography
        variant="h6"
        data-aos={'fade-up'}
        sx={{
          fontWeight: 700,
          marginBottom: 2,
        }}
      >
        Pre Primary  2025-26
      </Typography>
      <Grid container spacing={2}>
        {mockWithPdf.map((item, i) => (
          <Grid key={i} item xs={12}>
            <Box
              component={Card}
              width={1}
              height={1}
              boxShadow={0}
              borderRadius={0}
              display={'flex'}
              flexDirection={{ xs: 'column', md: 'row' }}
              sx={{ backgroundImage: 'none', bgcolor: 'transparent' }}
            >
              <Button 
                href={item.href}
                {...(item.href.endsWith('.pdf') && { target: '_blank', rel: 'noopener noreferrer' })}
              >
                <Typography component={'h6'}>
                  {item.description}
                </Typography>
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PreprimarySidebar2025;
